import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);
import VueMask from 'v-mask'
Vue.use(VueMask);

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import 'uikit/dist/css/uikit.min.css'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
/*import 'leaflet/dist/leaflet.css';*/

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.use(require('vue-moment'));
import { Icon } from 'leaflet';


delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
// loads the Icon plugin
UIkit.use(Icons);
import Home from '../views/Home.vue';
import FeastOfLight from "@/views/FeastOfLight";
import Alumni from "../views/Alumni";
import Parents from "../views/Parents";
import NewsAndEvents from "../views/NewsAndEvents";
import Students from "../views/Students";
import FacultyStaff from "../views/FacultyStaff";
import Giving from "../views/Giving";
import Accreditation from "../views/Accreditation";
import AdministrativeUnits from "../views/AdministrativeUnits";
import CollegeAndSchools from "../views/CollegeAndSchools";
import DiversityInclusion from "../views/DiversityInclusion";
import FAQs from "../views/FAQs";
import UndergradAdmission from "../views/UndergradAdmission";
import GraduateAdmission from "../views/GraduateAdmission";
import GeneralAdmission from "../views/GeneralAdmission";
import ApplicationForms from "../views/ApplicationForms";
import TuitionFees from "../views/TuitionFees";
import FinancialAid from "../views/FinancialAid";
import FutureNcu from "../views/FutureNcu";
import NcuWeAre from "../views/NcuWeAre";
import MeetOurLeaders from "../views/MeetOurLeaders";
import Clubs from "../views/Clubs";
import CampusLiving from "../views/CampusLiving";
import IntercolSports from "../views/IntercolSports";
import OpeningHours from "../views/OpeningHours";
import PublicSafety from "../views/PublicSafety";
import HealthWellness from "../views/HealthWellness";
import InternationalStudentServices from "../views/InternationalStudentServices";
import CounsellingAndPshychology from "../views/CounsellingAndPshychology";
import OnlineEducation from "../views/OnlineEducation";
import StudentAdvisementAndSuccess from "../views/StudentAdvisementAndSuccess";
import CCMPR from "../views/CCMPR";
import OfficeGraduateStudies from "../views/OfficeGraduateStudies";
import ScholarshipAndStudentAid from "../views/ScholarshipAndStudentAid";
import StudentFinance from "../views/StudentFinance";
import StudentEngagementAndRetention from "../views/StudentEngagementAndRetention";
import UNISS from "../views/UNISS";
import step from "../views/step";
import DentalHygiene from "../views/DentalHygiene";
import FitnessCentre from "../views/FitnessCentre";
import UnissComputerLabs from "../views/UnissComputerLabs";
import CareerServices from "../views/CareerServices";
import UniversityRecords from "../views/UniversityRecords";
import ContactUs from "../views/ContactUs";
import Bulletins from "../views/Bulletins";
import AcademicCalendar from "../views/AcademicCalendar";
import CertificatePrograms from "../views/CertificatePrograms";
import ExtensionPrograms from "../views/ExtensionPrograms";
import GradPrograms from "../views/GradPrograms";
import UndergradPrograms from "../views/UndergradPrograms";
import Minors from "../views/Minors";
import UndergradProgram from "../views/UndergradProgram";
import searchdegree from "../views/searchdegree";
import tests
    from "../views/test";


import GradProgram from "../views/GradProgram";
import rescueDonate from "../components/give/rescueDonate";
import Careers from "../views/Careers";
import AllFeatureStories from "../views/AllFeatureStories";
import FeatureStory from "../views/FeatureStory";
import EventCalendar from "../views/EventCalendar";
import ArrangeVisit from "../views/ArrangeVisit";
import CNAS from "../views/CNAS";
import hubbs from "../views/hubbs";
import BMH from "../views/BMH";
import SRT from "../views/SRT";
import EL from "../views/EL";
import NotFound from "../views/NotFound";
import ChurchAndCommunity from "../views/ChurchAndCommunity";
import virtualTour from "../components/shared/virtualTour";
import AllDepartments from "../views/AllDepartments";
import transferstudent from '../views/TransferStudent'
import InternationalStudents from "../views/InternationalStudents";
import ProvisionAcceptance from "../views/ProvisionAcceptance";
import donate from "../components/give/donate";
import searchDepartment from "../views/searchDepartment";
import PresidentMessage from "../views/PresidentMessage";
import RequestInformation from "../views/RequestInformation";
import KeywordSearch from "../views/KeywordSearch";
import AdmissionGrants from "../views/AdmissionGrants";
import CookieNotice from "@/components/Notices/CookieNotice.vue";
import PrivacyNotice from "@/components/Notices/PrivacyNotice.vue";
import DataProtectionNotice from "@/components/Notices/DataProtectionNotice.vue";
import cookieModal from "@/components/Notices/cookieModal.vue"
import brochure from "@/components/brochure.vue";
import NcuOvalRedevelopment from "@/views/NcuOvalRedevelopment.vue";
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/contactus', name: 'Contact Us', component: ContactUs },
  {path: '/feastOfLight', name: 'Feast Of Light', component: FeastOfLight},
  { path: '/accreditation', name: 'Accreditation', component: Accreditation },
  { path: '/adminunits', name: 'Administrative Units', component: AdministrativeUnits },
  { path: '/collegeschools', name: 'Colleges & School', component: CollegeAndSchools },
  { path: '/diversity', name: 'Diversity & Inclusion', component: DiversityInclusion },
  { path: '/faqs', name: 'Frequently Asked Questions', component: FAQs },
  { path: '/keywordsearch', name: 'Keyword Search', component: KeywordSearch },
  { path: '/generaladmission', name: 'General Admission', component: GeneralAdmission },
  //{ path: '/applicationforms', name: 'Application Forms', component: ApplicationForms },
  { path: '/bulletins', name: 'Bulletins', component: Bulletins },
  { path: '/academiccalendar', name: 'Academic Calendar', component: AcademicCalendar },
  { path: '/eventscalendar', name: 'Events Calendar', component: EventCalendar },
  { path: '/certificateprograms', name: 'Certificate Programs', component: CertificatePrograms },
  { path: '/extensionprograms', name: 'Extension Campus Programs', component: ExtensionPrograms },
  { path: '/gradprograms', name: 'Graduate Programs', component: GradPrograms },
  { path: '/grad/:id', name: 'Graduate Program', component: GradProgram,
    beforeEnter: async (to, from, next) => {
      //console.log(to.params.id)
      await store.commit('degree/GetGraduatePrograms', { data: to.params.id })
      /*router.beforeEach((to, from, next) => {
        program.GetAdditionalProgramInfo(0, to.params.id).title = `${to.meta.title}`
      })*/
      next()

    }
  },
  { path: '/undergradprograms', name: 'Undergraduate Programs', component: UndergradPrograms },
  { path: '/undergrad', name: 'Undergraduate  Program', component: UndergradProgram },
  { path: '/minors', name: 'Minors', component: Minors },
  { path: '/tuitionfees', name: 'Tuition And Fees', component: TuitionFees },
  { path: '/financialaid', name: 'Financial Aid', component: FinancialAid },
  { path: '/futurencu', name: 'Future of NCU', component: FutureNcu },
  { path: '/wearencu', name: 'We Are NCU', component: NcuWeAre },
  { path: '/meetourleaders', name: 'Meet Our Leaders', component: MeetOurLeaders },
  { path: '/clubs', name: 'Clubs', component: Clubs },
  { path: '/virtualtour', name: 'Virtual', component: virtualTour },
  { path: '/campusliving', name: 'Campus Living', component: CampusLiving },
  { path: '/intercolsports', name: 'Intercol Sports', component: IntercolSports },
  { path: '/openinghours', name: 'Campus Opening Hours', component: OpeningHours },
  { path: '/publicsafety', name: 'Public Safety', component: PublicSafety },
  { path: '/healthwellness', name: 'Health And Wellness', component: HealthWellness },
  { path: '/internationalstudents', name: 'International Student Services', component: InternationalStudentServices },
  { path: '/counsellingpsychology', name: 'Counselling And Psychology', component: CounsellingAndPshychology },
  { path: '/dentalhygiene', name: 'Dental Hygiene', component: DentalHygiene },
  { path: '/fitnesscentre', name: 'Fitness Centre', component: FitnessCentre },
  { path: '/unisscomputerlabs', name: 'Uniss Computer Labs', component: UnissComputerLabs },
  { path: '/careerservices', name: 'Career Services', component: CareerServices },
  { path: '/careers', name: 'Careers', component: Careers },
  { path: '/onlineeducation', name: 'Online Education', component: OnlineEducation },
  { path: '/academicadvisement', name: 'Academic Advisement and Student Success', component: StudentAdvisementAndSuccess },
  { path: '/ccmpr', name: 'Corporate Communications, Marketing And Public Relations', component: CCMPR },
  { path: '/graduatestudies', name: 'Office of Graduate Studies', component: OfficeGraduateStudies },
  { path: '/scholarshipandstudentaid', name: 'Scholarship And Student Aid', component: ScholarshipAndStudentAid },
  { path: '/studentfinance', name: 'Student Finance', component: StudentFinance },
  { path: '/studentengagementandretention', name: 'Student Engagement And Retention', component: StudentEngagementAndRetention },
  { path: '/step', name: 'Student Tertiary Experience Programme', component: step },
  { path: '/uniss', name: 'University Information System Services', component: UNISS },
  { path: '/records', name: 'University Records', component: UniversityRecords },
  { path: '/undergradadmission', name: 'Undergraduate Admission', component: UndergradAdmission },
  { path: '/graduateadmission', name: 'Graduate Admission', component: GraduateAdmission },
  { path: '/alumni', name: 'Alumni', component: Alumni },
  { path: '/parents', name: 'Parents', component: Parents },
  { path: '/newsandevents', name: 'News and Events', component: NewsAndEvents },
  { path: '/students', name: 'Students', component: Students },
  { path: '/president_message', name: 'NCU President\'s Message' , component: PresidentMessage },
  { path: '/facultystaff', name: 'Faculty And Staff', component: FacultyStaff },
  { path: '/giving', name: 'Giving', component: Giving },
  { path: '/rescuedonate', name: 'Rescue Donate Page', component: rescueDonate },
  { path: '/donate', name: ' Donate Page', component: donate },
  { path: '/allfeaturestories', name: 'Feature Stories', component: AllFeatureStories },
  { path: '/featurestory', name: 'Feature Story', component: FeatureStory },
  /*{ path: '/arrangevisit', name: 'Arrange Visit', component: ArrangeVisit },*/
  { path: '/college_hubbs', name: 'College of Humanities, Behavioural and Social Sciences', component: hubbs },
  { path: '/college_cnasahn', name: 'College of Natural & Applied Science, Allied Health & Nursing', component: CNAS },
  { path: '/college_bmh', name: 'College of Business Management & Hospitality', component: BMH },
  { path: '/college_el', name: 'College of Education & Leadership', component: EL },
  { path: '/college_srt', name: 'School of Religion & Theology', component: SRT },
  { path: '/churchandcommunity', name: 'Church And Community Relations', component: ChurchAndCommunity },
  { path: '/alldepartments', name: 'All Academic Departments', component: AllDepartments },
  { path: '/transfer_students', name: 'Transfer Students - Admission', component: transferstudent },
  { path: '/international_students', name: 'International Students - Admission', component: InternationalStudents },
  { path: '/provisional_acceptance', name: 'Provisional Acceptance - Admission', component: ProvisionAcceptance },
  { path: '/searchdegree', name: 'searchdegree', component: searchdegree },
  { path: '/searchDepartment', name: 'Search Departments', component: searchDepartment },
  { path: '/request_information', name: 'Request Information', component: RequestInformation },
  { path: '/brobook', name: 'NCU Academic Brochure', component: brochure },
  { path: '/grants', name: 'Recruitment & Admission Grants', component: AdmissionGrants },
  { path: '/cookies', name: 'Cookie Notice', component: CookieNotice },
  {path: '/privacy', name: 'Privacy Notice', component: PrivacyNotice},
  { path: '/dataProtection', name: 'Data Protection Notice', component: DataProtectionNotice },
  { path: '/cookieModal', name: 'Cookie Modal', component: cookieModal},
  { path: '/ncu-oval-redevelopment', name: 'Ncu Oval Redevelopment', component: NcuOvalRedevelopment},
  /*{ path: '/graduate_qr', name: 'Graduate Q-R', component:  },*/

  { path: '/test', name: 'test', component: tests },
  { path: '*', name: '', component: NotFound },

  /*{
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/!* webpackChunkName: "about" *!/ '../views/About.vue')
    }
  }*/
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
